module.exports = __webpack_public_path__ + "static/dylan-b6d4ea6f6f0c8ff9864a14587dff4215.gif";